import React from 'react';

const StepHeader = ( { steps, activeStep } ) => {
	return (<div className="step-header">
			{ steps.map( ( step, index ) => (<React.Fragment key={ step.id }>
					{ index > 0 && (<div
							className="step-line"
							style={ {
								'--progress': `${ step.id <= activeStep
								                  ? 100
								                  : 0 }%`
							} }
						/>
					) }
					<div className="step">
						<div className={ `step-icon ${ step.id === activeStep
						                               ? 'active'
						                               : '' } ${ step.id < activeStep
						                                         ? 'completed'
						                                         : '' }` }>
							{ step.id < activeStep ? (
								<i className="fa fa-check"></i>
							) : step.icon ? (typeof step.icon === 'string' ? (
									<i className={ `fa ${ step.icon }` }></i>
								) : (<step.icon/>
							                 )
							) : (step.id
							    ) }
						</div>
						<h4 className={ `step-name ${ step.id === activeStep
						                              ? 'active'
						                              : step.id < activeStep
						                                ? 'completed'
						                                : 'not-passed' }` }>{ step.name }</h4>
					</div>
				</React.Fragment>
			) ) }
		</div>
	);
};

export default StepHeader;